import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Import third-party styles first
import 'bootstrap/dist/css/bootstrap.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

// Import your own styles after
import './index.css';
import './main.css';
import ReactPixel from 'react-facebook-pixel';

const advancedMatching = { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");

  if (parts.length == 2) {
    return parts.pop().split(";").shift();
  } else if (value.startsWith(name + "=")) {
    return value.split(";")[0].substring(name.length + 1);
  }
}


if (getCookie('targeting_cookies') === 'true') {
  const pixelOptions = {
    autoConfig: true,  // set to false if you have events that should not trigger the pixel (optional)
    debug: false,       // enable logs for debugging (optional)
  };
  ReactPixel.init('1481514672539173', null, pixelOptions);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
